type PickupPointSelectorProps = {
  children: React.ReactNode | React.ReactNode[];
  UNSAFE_className?: string;
  isSelected?: boolean;
};

export const PickupPointSelector: React.FC<PickupPointSelectorProps> = ({
  children,
  UNSAFE_className,
  isSelected = false,
}) => {
  return (
    <div
      className={`${UNSAFE_className} ${
        isSelected ? 'tw-bg-beige-200' : 'tw-bg-transparent'
      } tw-rounded-lg tw-border-solid tw-border-blue-200 tw-p-3`}
    >
      {children}
    </div>
  );
};
